import GlobalModal from '../../../../components/GlobalModal';
import Default from 'components/fields/InputField';
import { Button, Text, Flex } from '@chakra-ui/react';

const ThresholdModal = ({
  isOpen,
  onClose,
  selectedParam,
  maxThreshold,
  minThreshold,
  setMaxThreshold,
  setMinThreshold,
  onAdd,
}) => {
  return (
    <GlobalModal isOpen={isOpen} onClose={onClose} title="Add Threshold">
      {selectedParam ? (
        <>
          <Text fontWeight="bold" mb={2}>
            Slave: {selectedParam.param.name}
          </Text>
          <Text fontWeight="bold" mb={2}>
            Parameter: {selectedParam.param.name}
          </Text>
          <Default
            label="Min Threshold"
            placeholder="Enter min threshold"
            type="number"
            value={minThreshold}
            onChange={(e) => setMinThreshold(e.target.value)}
            mb={3}
          />
          <Default
            label="Max Threshold"
            placeholder="Enter max threshold"
            type="number"
            value={maxThreshold}
            onChange={(e) => setMaxThreshold(e.target.value)}
            mb={3}
          />
        </>
      ) : (
        <Text>No parameter selected.</Text>
      )}
      <Flex justify="flex-end" mt={4}>
        <Button colorScheme="blue" onClick={onAdd}>
          ADD
        </Button>
      </Flex>
    </GlobalModal>
  );
};

export default ThresholdModal;
